import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { EventRepository }      from 'Domain/Repositories';
import { message }              from 'antd';

export const createEventEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createEventRequest.type),
    mergeMap(action => from(EventRepository.create(action.payload.formData))
      .pipe(
        mergeMap((event) => {
          message.success('Event wurde erfolgreich erstellt');
          return from([
            Actions.createEventSuccess({ event })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createEventFailure({ error }),
          ]);
        })
      )
    ),
  );
};
